"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = __importDefault(require("./styles"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
// 👀 exporting as a const in addition to default to fix issue where Storybook loses descriptions and defaults
// eslint-disable-next-line import/export, no-redeclare
var Row = function (props) {
    var _a = props.as, As = _a === void 0 ? 'div' : _a, _b = props.nested, nested = _b === void 0 ? false : _b, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, gridRowGap = props.gridRowGap, children = props.children, className = props.className, intrinsicElementProps = __rest(props, ["as", "nested", "fullWidth", "gridRowGap", "children", "className"]);
    (0, react_1.useEffect)(function () {
        if (typeof gridRowGap === 'number') {
            console.warn('Spacing units of type "number" are deprecated and will be removed in a future release. Use "small" | "medium" | "large" | "xlarge" | "xxlarge" instead.' +
                '\n\nSee https://mortar.policygenius.com/?path=/story/design-guidelines-layout--page#spacing-units for design guidelines.');
        }
    }, []);
    var componentStyles = useStyles({ gridRowGap: gridRowGap });
    var classes = (0, classnames_1.default)(componentStyles.row, componentStyles['row-sm'], componentStyles['row-md'], componentStyles['row-lg'], componentStyles['row-gap'], fullWidth && componentStyles['full-width'], nested && componentStyles.nested, className);
    return (react_1.default.createElement(As, __assign({ className: classes }, intrinsicElementProps), react_1.default.Children.map(children, function (child) {
        if (!child || typeof child === 'boolean')
            return null;
        if (typeof child.type === 'string') {
            return react_1.default.cloneElement(child, child.props);
        }
        if (child.type.displayName === 'Row') {
            throw new Error('A Row cannot be a direct descendant of a Row. You must use a Col component or any other HTML element.');
        }
        return react_1.default.cloneElement(child, child.props);
    })));
};
exports.Row = Row;
// Added for Storybook documentation to display "default" for each prop
exports.Row.defaultProps = {
    as: 'div',
    fullWidth: false,
    nested: false
};
